<!-- =========================================================================================
  File Name: UserList.vue
  Description: User List page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>

  <div id="page-user-list">
    <vx-card ref="filterCard" title="Filters" class="user-list-filters mb-8" >
      <div class="vx-row">
        <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
          <label class="vs-input--label">Type</label>
          <v-select :clearable="false" :options="typeList" :dir="$vs.rtl ? 'rtl' : 'ltr'" v-model="filter.type" class="mb-4 md:mb-0" />
        </div>
        <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
          <label class="vs-input--label">Date</label>
          <flat-pickr :config="{ dateFormat: 'Y-m-d' }" style="width: 100%" v-model="filter.date"/>
        </div>
        <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
          <vs-button id="searchBtn" style="width: 100%" color="success" type="filled" icon-pack="feather" icon="icon-search" class="pl-5 mt-1 vs-con-loading__container" @click="search">Search</vs-button>
        </div>
      </div>
    </vx-card>

    <div class="vx-card p-6">

      <div class="flex flex-wrap items-center">
        <div class="flex-grow">
          <vs-button v-if="data.length > 0" id="exportBtn" icon-pack="feather" icon="icon-file-text" color="success" type="border" class="mb-4 md:mb-0 vs-con-loading__container" @click="exportHistory">Export</vs-button>
        </div>

        <vs-dropdown vs-trigger-click class="cursor-pointer mr-2">
          <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
            <span class="mr-2">{{ page * per_page - (per_page - 1) }} - {{ row_total - page * per_page > 0 ? page * per_page : row_total }} of {{ row_total }}</span>
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
          </div>
          <vs-dropdown-menu>
            <vs-dropdown-item @click="updatePerPage(10)">
              <span>10</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="updatePerPage(25)">
              <span>25</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="updatePerPage(50)">
              <span>50</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="updatePerPage(100)">
              <span>100</span>
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>

      </div>
      <div class="table-container">
        <table class="table">
          <thead>
            <tr>
              <th>No</th>
              <th>Date</th>
              <th>Action Type</th>
              <th>Imei</th>
              <th>Serial Number</th>
              <th>Message</th>
              <th>User</th>
            </tr>
          </thead>
          <tbody v-if="loading">
            <tr>
              <td colspan="10" class="text-center">Loading....</td>
            </tr>
          </tbody>
          <tbody v-else-if="data.length > 0">
            <tr v-for='(item, index) in data' :key='index'>
              <td>{{ ((page-1)*per_page) + (index+1) }}</td>
              <td>{{ item.date }}</td>
              <td>{{ item.type }}</td>
              <td>{{ item.imei }}</td>
              <td>{{ item.sn }}</td>
              <td>{{ item.message }}</td>
              <td>{{ item.user }}</td>
            </tr>
          </tbody>
          <tbody v-else>
            <tr>
              <td colspan="10" class="text-center">No Data Available</td>
            </tr>
          </tbody>
        </table>

        <vs-pagination :total="n_page" v-model="page"></vs-pagination>
      </div>

    </div>
  </div>

</template>

<script>
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
import vSelect from 'vue-select'
import FileDownload from 'js-file-download'

export default {
  components: {
    flatPickr,
    vSelect
  },

  data () {
    return {
      data: [],
      token: '',
      action: '',
      loading: false,
      actor: '',
      tempId: 0,

      typeList: [
        { value: '', label: '-- All --' },
        { value: 'upload', label: 'Upload' },
        { value: 'update', label: 'Update' }
      ],

      filter: {
        date: null,
        type: { value: '', label: '-- All --' }
      },

      filtered: {
        date: null,
        type: { value: '', label: '-- All --' }
      },
      page: 1,
      per_page: 10,
      row_total: 0,
      keyword: '',

      timer: null,
      notify: 'Server Error',
    }
  },

  computed: {
    n_page() {
      return Math.ceil(this.row_total/this.per_page)
    },
  },

  watch: {
    page() {
      this.initTable()
    },

    per_page() {
      if(this.page != 1) this.page = 1
      else this.initTable()
    },
  },

  created () {
    this.token = localStorage.getItem('userInfo') !== null ? JSON.parse(localStorage.getItem('userInfo')).token : ''

    this.$http.get(`${this.$api.endpoint}/user/profile`, {
      headers: {
        Authorization: `Bearer ${this.token}`
      }
    }).then(res => {
      this.actor = res.data.message.data
    }).catch(error => {
      this.$gf.httpErrorHandler(error)
    })
  },

  mounted () {
  },

  methods: {
    updatePerPage(n) {
      this.per_page = n
    },

    initTable() {
      this.loading = true
      this.$http.get(`${this.$api.endpoint}/imei_upload/datatable`, {
        params: {
          page: this.page,
          per_page: this.per_page,
          date: this.filter.date,
          type: this.filter.type ? this.filter.type.value : ''
        },

        headers: {
            Authorization: `Bearer ${this.token}`
        }
      }).then(res => {
        this.loading = false
        this.$vs.loading.close(`#searchBtn > .con-vs-loading`)

        this.row_total = res.data.message.total
        this.data = res.data.message.data

      }).catch(error => {
        this.$vs.loading.close(`#searchBtn > .con-vs-loading`)
        this.$gf.httpErrorHandler(error)
      })
    },

    search() {
      this.loading = true
      this.$vs.loading({
        background: 'success',
        color: '#fff',
        container: "#searchBtn",
        scale: 0.45
      })

      this.filtered.date = this.filter.date
      this.filtered.type = this.filter.type.value

      this.page = 1
      this.initTable()

    },

    exportHistory() {
      this.$vs.loading({
        background: 'success',
        color: '#fff',
        container: "#exportBtn",
        scale: 0.45
      })

      this.$http.get(`${this.$api.endpoint}/imei_upload/export`, {
        responseType: 'blob',
        params: {
          date: this.filtered.date,
          type: this.filtered.type
        },

        headers: {
            Authorization: `Bearer ${this.token}`
        }
      }).then(res => {
        this.$vs.loading.close(`#exportBtn > .con-vs-loading`)

        let filename = `Import_Fail_Imei_${this.filtered.type}_${this.filtered.date.toString().substr(0, 10)}.xlsx`
        FileDownload(res.data, filename)

      }).catch(error => {
        this.$vs.loading.close(`#exportBtn > .con-vs-loading`)
        this.$gf.httpErrorHandler(error)
      })
    },

  },
}

</script>
